import React from "react";
import {
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { useSpeech } from "../utils/speech";
import { wordsData } from "../data/words";

const ListingScreen = ({ goBack }) => {
  const { speakWord } = useSpeech();

  return (
    <Box id="listingMode" className="screen" sx={{ p: 2 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        生字列表
      </Typography>
      <Grid container spacing={2} id="cardsGrid">
        {wordsData.map((word, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ border: "1px solid #ccc" }}>
              <CardContent>
                <Typography variant="h5" className="emoji">
                  {word.emoji}
                </Typography>
                <Typography variant="subtitle1" className="english">
                  {word.english}
                </Typography>
                <Typography variant="body2" className="chinese">
                  {word.chinese}
                </Typography>
                <Button
                  variant="outlined"
                  startIcon={<VolumeUpIcon />}
                  onClick={() => speakWord(word.english)}
                  sx={{ mt: 1 }}
                >
                  播放
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Button variant="contained" onClick={goBack} sx={{ mt: 3 }}>
        返回主目錄
      </Button>
    </Box>
  );
};

export default ListingScreen;
